import { GraphQLClient } from 'graphql-request'
import { getAuthToken } from '@/utilities/auth-token'
import LogRocket from 'logrocket'

export default class AlphaGraphQLClient extends GraphQLClient {
  // Dynamically sets the auth header for each request
  request<T extends any> (query: string, variables?: Record<string, any>): Promise<T> {
    const token = getAuthToken()
    const authVal = token ? `JWT ${token}` : ''
    this.setHeader('Authorization', authVal)
    const logRocketUrl = LogRocket.sessionURL
    if (logRocketUrl) this.setHeader('LogRocket-URL', logRocketUrl)
    return super.request(query, variables)
  }
}
